import type { SVGProps } from "react";

export function IconPurpleCart(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M22.5 7H52.5V37H22.5V7Z"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M57 42H16V7H7M58 51.5C58 54.5376 55.5376 57 52.5 57C49.4624 57 47 54.5376 47 51.5C47 48.4624 49.4624 46 52.5 46C55.5376 46 58 48.4624 58 51.5ZM26 51.5C26 54.5376 23.5376 57 20.5 57C17.4624 57 15 54.5376 15 51.5C15 48.4624 17.4624 46 20.5 46C23.5376 46 26 48.4624 26 51.5Z"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M34 7V14H41V7"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
